import * as React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import KeyboardReturnIcon from '@images/activate/ic_keyboard_return.svg';
import LaptopIcon from '@images/activate/ic_laptop_windows.svg';
import ShareIcon from '@images/activate/ic_share.svg';

const MobileNotSupportedComponent = () => {
	const url = window.location.href;
	const [copied, setCopied] = React.useState(false);

	return (
		<div className="bg-white p-10">
			<div className="flex justify-between mb-[15px]">
				<div className="flex items-center">
					<div className="text-lg text-black font-bold mr-[2rem]">Frodobots</div>
				</div>

				<div className="flex items-center">
					<div className="bg-[#25BD66] p-[10px] rounded-3xl text-white font-600 max-w-[200px] text-center text-sm">
						<img
							className="mr-[5px] w-[20px]"
							src={KeyboardReturnIcon}
							alt="img-fluid"
						/>
						frodobots.com
					</div>
				</div>
			</div>

			<div className="flex flex-col h-[90vh] p-[20px] bg-[#EFEFEF] justify-center rounded-md text-center items-center">
				<div className="flex">
					<img
						src={LaptopIcon}
						alt="img-fluid"
					/>
				</div>

				<div className="mb-[20px]">
					<h3>Please use a laptop or desktop to continue</h3>
				</div>

				<div className="text-xs">
					<div className="mb-[20px]">
						Hello! In order to activate your FrodoBot, you need to visit this website through a desktop or laptop
					</div>
					<div className="mb-[30px]">
						You can click below to share this link to your other device to make this easier.
					</div>

					<div className="bg-black p-[10px] rounded-3xl text-white text-xs">
						<CopyToClipboard
							text={url}
							onCopy={() => setCopied({ copied: true })}
						>
							<button aria-label="Share link">
								{copied ? (
									'Copied'
								) : (
									<>
										<img
											className="mr-[10px]"
											src={ShareIcon}
											alt="img-fluid"
										/>
										Share link
									</>
								)}
							</button>
						</CopyToClipboard>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MobileNotSupportedComponent;
